import { render } from "./UserAccount.vue?vue&type=template&id=4dbd788e&scoped=true"
import script from "./UserAccount.vue?vue&type=script&lang=js"
export * from "./UserAccount.vue?vue&type=script&lang=js"

import "./UserAccount.vue?vue&type=style&index=0&id=4dbd788e&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dbd788e"]])

export default __exports__